import RequestService from '@tcc-online/request-service';

import { SaveProfilePayload } from '../../actions/ProfileActions';
import { IUser } from '../../types';

const BASE_URL = '/users/';

const ProfileService = {
    getProfile,
    saveProfile,
};

async function getProfile(payload: { userId: number }) {
    return await RequestService.get<IUser>(BASE_URL + payload.userId);
}

function saveProfile(payload: SaveProfilePayload) {
    const { userId, firstName, lastName } = payload;
    return RequestService.put(BASE_URL + userId, {
        firstName,
        lastName,
    });
}

export default ProfileService;
